import { render, staticRenderFns } from "./manageSubgroupFeeStructure.vue?vue&type=template&id=4f774268&scoped=true"
import script from "./manageSubgroupFeeStructure.vue?vue&type=script&lang=js"
export * from "./manageSubgroupFeeStructure.vue?vue&type=script&lang=js"
import style0 from "./manageSubgroupFeeStructure.vue?vue&type=style&index=0&id=4f774268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f774268",
  null
  
)

export default component.exports